<template>
	<v-container class="d-flex flex-column justify-center">
		<ChannelDropdown
			v-if="midiConnected"
			:channel-data="channelData"
			:controller-type="controllerType"
			:all-channels="allChannels"
			@update-assigned-channel="updateAssignedChannel"
		/>

		<div class="d-flex justify-center">
			<LCD :channel-data="channelData" :all-channels="allChannels" />
		</div>

		<div v-if="controllerType !== ControllerTypes.Rodecaster" class="d-flex align-self-center">
			<TopButton text="PGM" position="button1" :channel-data="channelData" />
			<TopButton text="CUE" position="button2" :channel-data="channelData" />
		</div>

		<Fader :channel-data="channelData" :controller-type="controllerType" />

		<div v-if="controllerType !== ControllerTypes.Rodecaster" class="d-flex flex-column align-center">
			<BottomButton position="button3" :channel-data="channelData" />
			<BottomButton position="button4" :channel-data="channelData" />
		</div>
	</v-container>
</template>

<script>
/* Modules */
import ChannelDropdown from "@/components/midi/ChannelDropdown.vue";
import BottomButton from "@/components/midi/BottomButton.vue";
import Fader from "@/components/midi/Fader.vue";
import LCD from "@/components/midi/LCD.vue";
import TopButton from "@/components/midi/TopButton.vue";

/* Enums */
import ControllerTypes from "@/enums/ControllerTypes";

export default {
	name: "Channel",

	components: {TopButton, LCD, Fader, BottomButton, ChannelDropdown},

	props: ["channelData", "allChannels", "midiConnected", "controllerType"],

	emits: ["updateAssignedChannel"],

	data() {
		return {
			pages: null,
			hotkeyEvent: null,
			userID: null
		};
	},

	computed: {
		ControllerTypes() {
			return ControllerTypes;
		},

		studioSettings() {
			return this.$store.getters.getStudioSettings();
		}
	},

	methods: {
		updateAssignedChannel: function (ev) {
			this.$emit("updateAssignedChannel", ev);

			if (this.controllerType === ControllerTypes.Default) {
				this.studioSettings.preferences.midi = {
					...this.studioSettings.preferences.midi,
					...{
						default: this.allChannels.map(channel => {
							return {
								id: channel.mode === "track_control" ? channel.channelNumber : channel.id,
								assignment: channel.assignment
							};
						})
					}
				};
			} else if (this.controllerType === ControllerTypes.Rodecaster) {
				this.studioSettings.preferences.midi = {
					...this.studioSettings.preferences.midi,
					...{
						rodecaster: this.allChannels.map(channel => {
							return {
								id: channel.mode === "track_control" ? channel.channelNumber : channel.id,
								assignment: channel.assignment
							};
						})
					}
				};
			}

			this.$store.dispatch("editStudioSettings", this.studioSettings);
		}
	}
};
</script>

<style scoped lang="scss">
.v-container {
	> * {
		padding: 6px 0;
	}
}
</style>
